import { useState } from 'react';

import { MenuItem, MenuItemProps } from '@mui/material';

interface MenuItemWithDoubleClickPreventionProps
  extends Omit<MenuItemProps, 'onClick' | 'disabled'> {
  onClick: () => Promise<void> | void;
  isDisabled?: boolean;
}

function MenuItemWithDoubleClickPrevention({
  onClick,
  children,
  isDisabled = false,
  ...rest
}: MenuItemWithDoubleClickPreventionProps) {
  const [isClickDisabled, setIsClickDisabled] = useState<boolean>(false);
  const isItemDisabled = isDisabled || isClickDisabled;

  const handleClick = async (): Promise<void> => {
    if (isItemDisabled) return;

    setIsClickDisabled(true);

    try {
      await onClick();
    } finally {
      setTimeout(() => {
        setIsClickDisabled(false);
      }, 1000);
    }
  };

  return (
    <MenuItem onClick={handleClick} disabled={isItemDisabled} {...rest}>
      {children}
    </MenuItem>
  );
}

export { MenuItemWithDoubleClickPrevention };
